import type { YandexMetrikaOptions } from './types';

export function initYandexMetrika(): void {
  const metrikaId = import.meta.env.VITE_YANDEX_METRIKA_ID;

  if (!metrikaId || metrikaId === '00000000' || import.meta.env.DEV) return;

  const scriptSrc = 'https://mc.yandex.ru/metrika/tag.js';

  const isLoaded = Array.from(document.scripts).some(
    (script) => script.src === scriptSrc
  );

  if (isLoaded) return;

  window.ym =
    window.ym ||
    function (...args: any[]) {
      (window.ym as any).a = (window.ym as any).a || [];
      (window.ym as any).a.push(args);
    };

  (window.ym as any).l = Date.now();

  const script = document.createElement('script');
  script.async = true;
  script.src = scriptSrc;
  document.head.appendChild(script);

  const options: YandexMetrikaOptions = {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
  };

  window.ym(metrikaId, 'init', options);
}